import { OiGroupDialogData, OiGroupProcessDialogComponent } from 'src/app/shared/oi-group-process-dialog/oi-group-process-dialog.component';
import { BaseService } from 'src/app/core/services/base.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmDialogTemplateComponent } from '@optsolservices/ngx-confirm-dialog';

@Component({
  selector: 'app-pos-refund-deposit-dialog',
  templateUrl: './pos-refund-deposit-dialog.component.html',
  styleUrls: ['./pos-refund-deposit-dialog.component.scss']
})
export class PosRefundDepositDialogComponent implements OnInit {
  busy: boolean = false;
  public salesOrder: any;

  storeId: number;
  containerId: number;
  refundReasonId: number;
  equipmentTypeCode: string;
  formValid: boolean = false;
  formValue: any;

  constructor(
    public dialogRef: MatDialogRef<PosRefundDepositDialogComponent>,
    private baseService: BaseService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog
  ) {
    this.salesOrder = data;
  }


  ngOnInit() {

  }

  paymentChanged(event: {
    storeId: number;
    containerId: number;
    equipmentTypeCode: string;
    formValid: boolean;
    formValue: any;
  }) {
    this.storeId = event.storeId;
    this.containerId = event.containerId;
    this.equipmentTypeCode = event.equipmentTypeCode;
    this.formValid = event.formValid;
    this.formValue = event.formValue;
  }

  refundReasonChanged(event: {
    refundReasonId: number;
  }) {
    this.refundReasonId = event.refundReasonId;
  }

  save() {

    if (this.formValue.amountTendered > this.salesOrder.depositOutstanding * -1) {
      const dialogRef = this.dialog.open(ConfirmDialogTemplateComponent, {
        width: '450px',
        data: {
          title: 'Refunding more than balance',
          text: `Refunding more (${(this.formValue.amountTendered).toFixed(2)}) than what's left as a deposit (${(this.salesOrder.depositOutstanding * -1).toFixed(2)}) is not allowed.`,
          cancelButtonText: 'Ok',
          showConfirmButton: false,
          showCancelButton: true
        }
      });

    } else {
      if (this.equipmentTypeCode === 'TFGVISION') {
        const payload = {
          salesOrderNumber: this.data.erpSalesOrderNumber,
          storeId: this.storeId,
          containerId: this.containerId,
          refundReasonId: this.refundReasonId,
          amountPaid: this.formValue.amountTendered,
          paymentData: this.formValue
        };

        const dialogData: OiGroupDialogData = {
          title: 'Authorizing TFG Credit Card',
          function: 'portal_oi_group_refund_tfg_deposit',
          postBody: payload
        };

        const ref = this.dialog.open(OiGroupProcessDialogComponent, {
          data: dialogData,
          width: '450px'
        });

        ref.afterClosed().subscribe(oiResult => {
          if (oiResult.responseCode === 0 && oiResult.data && oiResult.data.groupProcessedSuccessfully === true) {
            this.dialogRef.close(true);
          }
        });

      } else {
        this.busy = true;
        this.baseService.executeCommand<any>('portal_pos_payment_refund_deposit', {
          salesOrderNumber: this.data.erpSalesOrderNumber,
          storeId: this.storeId,
          containerId: this.containerId,
          refundReasonId: this.refundReasonId,
          amountPaid: this.formValue.amountTendered,
          paymentData: this.formValue
        }).subscribe(
          response => {
            if (response.responseCode === 0) {
              this.dialogRef.close(true);
            } else {
              this.busy = false;
            }
          },
          error => {
            this.busy = false;
          });
      }
    }
  }
}
